export default __webpack_public_path__ + "static/media/Hyrkanian Pale Ghost-Chaser.31137c9f.jpg";